import React from 'react';
import { AlertTriangle, Clock, PauseCircle, FileX, FileText } from 'lucide-react';
import { UrgentActionData } from '../data/mockData';
interface UrgentActionTilesProps {
  urgentActions: UrgentActionData;
}
export function UrgentActionTiles({
  urgentActions
}: UrgentActionTilesProps) {
  const tiles = [{
    id: 'final-cd',
    label: 'Final CD Signing Times',
    value: urgentActions.finalCDSigningTimes,
    subtitle: 'Approaching deadline',
    icon: Clock,
    accent: 'red' as const
  }, {
    id: 'suspended',
    label: 'Suspended Loans',
    value: urgentActions.suspendedLoans,
    subtitle: 'Requires immediate review',
    icon: PauseCircle,
    accent: 'red' as const
  }, {
    id: 'initial-cd',
    label: 'Initial CDs Out - Not Signed',
    value: urgentActions.initialCDsNotSigned,
    subtitle: 'Awaiting borrower signature',
    icon: FileX,
    accent: 'amber' as const
  }, {
    id: 'initial-disclosures',
    label: 'Initial Disclosures Ready - Not Signed',
    value: urgentActions.initialDisclosuresNotSigned,
    subtitle: 'Awaiting borrower signature',
    icon: FileText,
    accent: 'orange' as const
  }];
  const accentStyles: Record<string, {
    icon: string;
    glow: string;
    border: string;
  }> = {
    red: {
      icon: 'text-red-400 bg-red-500/15',
      glow: 'bg-red-500',
      border: 'hover:border-red-500/50'
    },
    amber: {
      icon: 'text-amber-400 bg-amber-500/15',
      glow: 'bg-amber-500',
      border: 'hover:border-amber-500/50'
    },
    orange: {
      icon: 'text-orange-400 bg-orange-500/15',
      glow: 'bg-orange-500',
      border: 'hover:border-orange-500/50'
    }
  };
  return <section data-id="element-374">
      <div className="flex items-center gap-2 mb-4" data-id="element-375">
        <span className="w-1.5 h-5 bg-red-500 rounded-full" data-id="element-376"></span>
        <h2 className="text-lg font-semibold text-white flex items-center gap-2" data-id="element-377">
          Urgent Action Required
        </h2>
        <AlertTriangle className="w-5 h-5 text-red-500" data-id="element-378" />
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-379">
        {tiles.map(tile => {
        const styles = accentStyles[tile.accent];
        const Icon = tile.icon;
        return <div key={tile.id} className={`bg-slate-800/80 border border-slate-700/50 rounded-xl p-5 ${styles.border} transition-all duration-200 shadow-lg group relative hover:bg-slate-800`} data-id="element-380">
              {/* Top glow */}
              <div className="absolute top-0 left-0 w-full overflow-hidden rounded-t-xl" data-id="element-381">
                <div className={`w-full h-0.5 opacity-50 group-hover:opacity-100 transition-opacity ${styles.glow}`} data-id="element-382" />
              </div>

              <div className="flex items-start justify-between mb-3" data-id="element-383">
                <div className={`p-2 rounded-lg ${styles.icon}`} data-id="element-384">
                  <Icon className="w-5 h-5" data-id="element-385" />
                </div>
              </div>

              <div className="text-2xl sm:text-3xl font-bold text-white tracking-tight mb-1" data-id="element-386">
                {tile.value}
              </div>

              <div className="text-sm font-medium text-slate-300" data-id="element-387">
                {tile.label}
              </div>
              <div className="text-sm text-slate-400 mt-0.5" data-id="element-388">
                {tile.subtitle}
              </div>
            </div>;
      })}
      </div>
    </section>;
}